import { any, async, jsxToWidget, nothing, stateful } from "widgets-for-react";
import { RecentNewsBlockLayout } from "./recentNewsBlockLayout";
import { initialState } from "./recentNewsBlockState";
export const RecentNewsBlock = (props)=>stateful({
        key: 'recent_news_block'
    })((s0)=>any()([
            jsxToWidget(RecentNewsBlockLayout({
                ...s0,
                ...props,
                key: 'recentNewsBlock'
            })),
            async(nothing, {
                key: 'recentNewsLoader'
            })(s0.items).map((itemsUpdater)=>(s1)=>{
                    return {
                        items: itemsUpdater(s1.items)
                    };
                })
        ]).map((a)=>a(s0)))(initialState(props)).run((_)=>{});
